module.exports = __webpack_public_path__ + "img/arrow-right.4b244411.svg";